import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { logUrlEvent } from '@/lib/urlMonitor';

interface Props {
  to: string;
  replace?: boolean;
}

/**
 * <Navigate> that also logs the hit as a legacy redirect so admins can
 * monitor how often each legacy path is still being requested.
 */
export function LoggedNavigate({ to, replace = true }: Props) {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    logUrlEvent('legacy_redirect', pathname + search + hash);
  }, [pathname, search, hash]);
  return <Navigate to={to} replace={replace} />;
}
